import type { TranslationKey } from '@/lib/i18n';

export const HEADER_ACCESSIBILITY_OPEN_CART = [
  'common:header.openCart',
  'Open cart',
] as const satisfies TranslationKey;

export const HEADER_ACCESSIBILITY_HOME = [
  'common:header.home',
  'Home',
] as const satisfies TranslationKey;

export const HEADER_ACCESSIBILITY_NAV_MENU = [
  'common:header.navigationMenu',
  'Navigation menu',
] as const satisfies TranslationKey;

export const HEADER_ACCESSIBILITY_CLOSE_MENU = [
  'common:header.closeMenu',
  'Close menu',
] as const satisfies TranslationKey;

export const HEADER_ACCESSIBILITY_OPEN_MENU = [
  'common:header.openMenu',
  'Open menu',
] as const satisfies TranslationKey;

export const HEADER_LABEL_MY_ACCOUNT = [
  'common:header.myAccount',
  'My account',
] as const satisfies TranslationKey;

export const HEADER_LABEL_MY_ACCOUNT_DRAWER = [
  'common:header.myAccountDrawer',
  'My Account',
] as const satisfies TranslationKey;

export const HEADER_LABEL_SEARCH_PRODUCTS = [
  'common:header.searchProducts',
  'Search products',
] as const satisfies TranslationKey;

export const HEADER_PLACEHOLDER_SEARCH_PRODUCTS = [
  'common:header.searchProductsPlaceholder',
  'Search products...',
] as const satisfies TranslationKey;
